

































































import Vue from 'vue';

export default Vue.extend({
  props: {
    open: {
      type: Boolean,
      required: false,
      default: false,
    },
    message: {
      type: String,
      required: false,
      default: 'Deseja cancelar o cadastro deste produto?',
    },
    screenTitle: {
      type: String,
      required: false,
      default: 'cadastro de produto',
    },
  },
  data(): { dialog: false } {
    return {
      dialog: false,
    };
  },
  computed: {},
  methods: {
    close(): void {
      this.dialog = false;
      this.$emit('close');
    },
    exit(): void {
      this.dialog = false;
      this.$emit('exit');
    },
  },
  watch: {
    open(newVal): void {
      if (this.dialog !== newVal) {
        this.dialog = newVal;
      }
    },
  },
});
